var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.857L1.643 5.214.463 4.036 4 .5l3.536 3.536-1.18 1.178L4 2.857z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/chevron-up-2.svg";
export { SvgChevronUp2 as ReactComponent };